import { Card } from '@helix-ds/react'
import { LockTime } from 'flowbite-react-icons/outline'

const HEADING = 'text-text-heading dark:text-white font-semibold tracking-tight'
const SUBTLE = 'text-sm font-medium text-text-body-subtle dark:text-gray-500'

/**
 * Full-screen blocking lockout shown when an Epic (SMART on FHIR) launched
 * session's access token has reached its ~1 hour expiry (minus a safety buffer).
 *
 * Epic access tokens cannot be refreshed in this app — obtaining a new one
 * requires a fresh SMART launch token from Epic. So there is no in-app re-auth
 * action; the clinician must relaunch the app from within Epic. This screen
 * blocks all further interaction to prevent downstream Epic/FHIR calls from
 * failing on an expired token.
 */
export default function EpicSessionLockout() {
  return (
    <main
      className="flex min-h-screen w-full items-center justify-center bg-background-variant-gray dark:bg-gray-950 p-6"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="epic-session-lockout-heading"
      aria-describedby="epic-session-lockout-description"
    >
      <Card className="w-full max-w-md" aria-labelledby="epic-session-lockout-heading">
        <div className="flex flex-col items-center gap-4 text-center">
          <span
            className="flex h-12 w-12 items-center justify-center rounded-full bg-warning-100 dark:bg-gray-900"
            aria-hidden="true"
          >
            <LockTime className="h-6 w-6 text-warning-600" />
          </span>
          <h1 id="epic-session-lockout-heading" className={`${HEADING} text-xl`}>
            Your Epic session has expired
          </h1>
          <div id="epic-session-lockout-description" className="flex flex-col gap-3">
            <p className="text-sm font-medium text-text-body dark:text-gray-400">
              For your security, this session timed out after one hour. To continue, please
              return to Epic and relaunch the application.
            </p>
            <p className={SUBTLE}>
              Any changes you were working on may not have been saved. Relaunching from Epic
              will start a fresh, secure session.
            </p>
          </div>
        </div>
      </Card>
    </main>
  )
}
